module.exports = __webpack_public_path__ + "img/hr_co.af6a6ef0.gif";